import React from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO, { BreadcrumbSchema } from "../components/SEO";
import HowWeWork from "../components/HowWeWork";
import AreasWeServe from "../components/AreasWeServe";
import BrandMark from "../components/BrandMark";
import { ArrowUpRight } from "lucide-react";

const CARDS = [
  { to: "/custom-homes", title: "Custom Homes", desc: "Architect-designed homes, planned and built with engineering discipline.", img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/d820c5d4f0710f07_bcpeabody-tampa-bay-custom-home-build-06-dried-in.jpg" },
  { to: "/renovations", title: "Renovations & Additions", desc: "Major renovations and additions, planned so you can live through them.", img: "https://customer-assets.emergentagent.com/job_company-site-new/artifacts/hc9pzs46_After%202.jpeg" },
  { to: "/kitchen-and-bath", title: "Kitchen & Bath", desc: "Kitchens and baths rebuilt the right way, behind the walls and on the surface.", img: "https://customer-assets.emergentagent.com/job_company-site-new/artifacts/gfxrb2yy_After%201.jpeg" },
  { to: "/commercial-construction", title: "Commercial", desc: "Retail, franchise, institutional and healthcare build-outs.", img: "https://customer-assets.emergentagent.com/job_company-site-new/artifacts/ci6ibh3r_image.png" },
];

export default function Construction() {
  return (
    <>
      <SEO title="Construction Services in Tampa" description="Custom homes, renovations, kitchens and baths, and commercial build-outs across Tampa Bay and Florida from an engineer-led general contractor." path="/construction" />
      <BreadcrumbSchema items={[{ name: "Home", url: "https://bcpeabody.com/" }, { name: "Construction", url: "https://bcpeabody.com/construction" }]} />
      <Nav transparentOnTop />

      <section className="relative min-h-[55vh] flex items-end overflow-hidden bg-ink text-cream-light">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-copper/10 blur-[160px]" />
        </div>
        <div className="relative max-w-[1200px] mx-auto px-6 md:px-10 w-full pb-14 pt-32">
          <div className="text-[11px] tracking-[0.18em] uppercase text-copper-light mb-5">Construction</div>
          <h1 className="font-serif font-medium tracking-tight mb-5 leading-[1.05]" style={{ fontSize: "clamp(32px, 5vw, 60px)" }}>Construction</h1>
          <p className="text-cream-light/80 max-w-3xl" style={{ fontSize: 18 }}>Homes, renovations and commercial build-outs across Tampa Bay and Florida.</p>
        </div>
      </section>

      <section className="bg-cream-light py-16 md:py-20">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {CARDS.map((c) => (
            <Link key={c.to} to={c.to} data-testid={`construction-card-${c.to.slice(1)}`} className="group block">
              <div className="relative h-[320px] overflow-hidden bg-ink mb-4 flex items-center justify-center">
                {c.img ? (
                  <img src={c.img} alt={c.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-[1200ms]" />
                ) : (
                  <BrandMark variant="icon" linked={false} size="lg" tone="light" />
                )}
              </div>
              <h3 className="font-serif text-2xl text-ink tracking-tight mb-1">{c.title}</h3>
              <p className="text-sm text-ink/70">{c.desc}</p>
              <span className="inline-flex items-center gap-1 text-[11px] tracking-[0.14em] uppercase text-copper mt-3">Learn more <ArrowUpRight size={12} /></span>
            </Link>
          ))}
        </div>
      </section>

      <HowWeWork />
      <AreasWeServe />

      <section className="bg-ink text-cream-light py-20 text-center">
        <div className="max-w-[800px] mx-auto px-6">
          <h2 className="font-serif font-medium mb-8 tracking-tight" style={{ fontSize: "clamp(26px, 3.2vw, 36px)" }}>Planning a project?</h2>
          <Link to="/contact" className="btn-copper">Start a Project →</Link>
        </div>
      </section>

      <Footer />
    </>
  );
}
